import { useRemoveExternalSchedule } from '@services/schedules/external/remove';
import { useCompleteTask } from '@services/tasks/complete';
import { useRevertTask } from '@services/tasks/revert';
import { ExternalScheduleActionsProps } from './types';

export const useExternalScheduleActions = ({
  setOpen,
  locked,
  completed,
  jobId,
  taskId: id,
  scheduleId,
  concreteDirectId,
  readOnly,
  scheduleType,
  unsavedChanges,
}: ExternalScheduleActionsProps) => {
  const complete = useCompleteTask();
  const revert = useRevertTask();

  const removeSchedule = useRemoveExternalSchedule({
    id: scheduleId || '',
    jobId: jobId || '',
    taskId: id,
    callback: (resp) => {
      if (!resp) return;
      const { success } = resp;
      if (!success) return;
      setOpen(false);
    },
  });

  const toggleDone = () => {
    if (!id || !jobId) return;
    if (completed) revert.mutate({ id, jobId });
    else complete.mutate({ id, jobId });
    setOpen(false);
  };

  const disabled = complete.isLoading || revert.isLoading || removeSchedule.isLoading || locked;
  const newSchedule = !scheduleId || scheduleId === 'new';

  return {
    toggleDone,
    removeSchedule,
    disabled,
    newSchedule,
    canMarkDone: !readOnly && Boolean(id),
    markDoneDisabled:
      (!scheduleId && !completed) || disabled || Boolean(concreteDirectId) || unsavedChanges,
    canRemove: !readOnly && !newSchedule && scheduleType !== 'dependent',
    removeDisabled: newSchedule || completed || disabled,
    saveDisabled: completed || disabled || (newSchedule && Boolean(concreteDirectId)),
  };
};
